export default "__VITE_ASSET__D_mC3TBs__"